import { Card, Grid, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import * as MuiIcons from '@mui/icons-material';
import React, { Key, useEffect, useState, useCallback } from "react";
import {getHeaders} from "../../../auth/authService";
import { useParams, useSearchParams } from "react-router-dom";
import { 
    DashBoard, 
    DashboardComponentGroup, 
    DashBoardComponent, 
    getPropertyDetails, 
    convertDate
} from "lib/dashboard";
import { CostData } from "types/costData";
import BarStatisticsCard from "examples/Cards/StatisticsCards/BarStatisticsCard";
import LoadingSpinner from "components/Spinner";
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import MDButton from "components/MDButton";
import Link from "@mui/material/Link";
import { useCache } from 'lib/CacheContext'; 
interface DateValue {
    date: string;
    value: number;
  }
interface DataPageProps {
    title: string
  }

  type DashboardComponentProps = {
    component: DashBoardComponent;
    glTotals: any;
    chartData: any;
    itemIndex: number;
  };

  const iconLookup: { [key: string]: React.ElementType } = {
    People: MuiIcons.People,
    Restaurant: MuiIcons.Restaurant,
    ViewDay: MuiIcons.ViewDay,
    BedroomParent: MuiIcons.BedroomParent,
    Paid: MuiIcons.Paid,
    CleaningServices: MuiIcons.CleaningServices
  };



  type DashboardComponentGroupProps = {
    group: DashboardComponentGroup;
    glTotals: any
  };

  function getCacheKey(did:string, fdate:Date,tdate:Date): string {
        console.log("cache date: ", fdate)
        if(tdate){
            return `${did}:${fdate.toISOString().split('T')[0]}:${tdate.toISOString().split('T')[0]}`
        }else{
            return ""
        }
    }

const DataPage = React.memo((): JSX.Element => {
    const cache = useCache();

    const dollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });

    const percentage = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    function formatValue(prefix: string, value: number): string  {
        switch (prefix) {
            case "$":
                return dollar.format(value)
                break;
            case "%":
                return percentage.format(value)
                break;      
            default:
                return value.toString()
                break;
        }
    }



    const DashboardComponentItem: React.FC<DashboardComponentProps> = React.memo(({ component, chartData, itemIndex }) => {
        return (
            
                <Grid item lg={component.Size>0?component.Size:12} py={2}>
                    <BarStatisticsCard
                        color="info"
                        title={component.Name}
                        count={formatValue(component.Prefix, dashboardData[itemIndex].currentTotal)}
                        variance={{
                            color: `${dashboardData[itemIndex].variance>0?"success":"error"}`,
                            value: `${formatValue(component.Prefix,dashboardData[itemIndex].previousTotal)}`
                        }}
                        target={formatValue(component.Prefix, dashboardData[itemIndex].target)}
                        previous={{
                            color: `${dashboardData[itemIndex].lastYear<dashboardData[itemIndex].currentTotal?"success":"error"}`,
                            value: `${formatValue(component.Prefix, dashboardData[itemIndex].lastYear)}`
                        }}
                        chartData={chartData}
                        chartLabel={component.Label}
                        size={component.Size>0?component.Size:12}
                    />
                </Grid>
            
        );
      })

      const DashboardComponentGrp: React.FC<DashboardComponentGroupProps> = React.memo(({ group, glTotals }) => {
        return (
            <Grid item lg={12}>
                <MDTypography py={2}>
                    <h3>
                        <Link href={`/dashboard/accomodation/reservations?propertyId=${pid}&companyId=${cid}&sd=${convertDate(startDate)}&ed=${convertDate(endDate)}`} color="Grey">{group.Name}</Link>
                    </h3>
                </MDTypography>
                <Grid container spacing={3} alignItems="center">

                    {/* Loop through at this level for each component */}
                    {group.Components.map((component: DashBoardComponent, index: Key) => {
                        const itemIndex = dashboardData.findIndex((item: { accountID: string; }) => item.accountID === component.AccountID);
                        console.log("🚀 ~ file: index.tsx:139 ~ {group.Components.map ~ itemIndex:", itemIndex)
                        const chartData: DateValue[] = dashboardData[itemIndex].chartData
                        return (
                        <DashboardComponentItem key={index} component={component} glTotals={glTotals} chartData={chartData} itemIndex={itemIndex}/>
                    )}
                        )}
    
                </Grid>
            </Grid>
        );
      });

    const initCostData: CostData = {
        "currentTotal":0,
        "previousTotal":0,
        "variance":0
      }

    type ComponentData = {
        "Key": string,
        "Values": CostData
    }
 
    const [startDate , setStartDate] = useState<Date>()
    const [endDate , setEndDate] = useState<Date>()
    const [startDisplayDate , setStartDisplayDate] = useState<any>(null)
    const [endDisplayDate , setEndDisplayDate] = useState<any>(null)
    const [headers,setHeaders] = useState<HeadersInit>()
    // const [searchParams] = useSearchParams();
    // const pid = searchParams.get("propertyId") 
    // const cid = searchParams.get("companyId")
    const { propertyId: pid, companyId: cid} = useParams();

    const [searchParams] = useSearchParams();
    // const pid = searchParams.get("propertyId") 
    // const cid = searchParams.get("companyId")
    const sd = searchParams.get("sd")
    const ed = searchParams.get("ed")
    const did = "8ae33a7d0ecb82cae8f04aafab20bf90425b7b"  //TODO: work out how to code this
    const [isLoading, setIsLoading] = useState(true);
    const [propSetup, setPropSetup] = useState(false)
    const [refresh, setRefresh] = useState<any>(null)
    const [dashboard, setDashboard] = useState<DashBoard>(null)
    const [dashboardData, setDashboardData] = useState<any>([])
    const [property, setProperty] = useState<any>(false)
    const [glTotals, setGLTotals] = useState<any[]>([]);

    // 1) Load Property and Headers
    useEffect(() => {
      const setup =async () => {
        if(sd&&ed){
            setStartDate(new Date(sd))
            setEndDate(new Date(ed))
            setStartDisplayDate(new Date(sd))
            setEndDisplayDate(new Date(ed))
        }else{
            setPreviousWeekDates()
        }
          
          const hdrs = await getHeaders()
          setHeaders(hdrs)
          setProperty(await getPropertyDetails(pid,cid,hdrs))
          setPropSetup(true)
        }
        setup()
      },[])

    // 2) Get Dashboard components and data
    useEffect(() => {
        console.log("startDate: ", startDate)
        console.log("endDate", endDate)
        const fetchData = async () => {
            setIsLoading(true)
            const db = await getDashboard();
            if(db){
                //console.log("db: ", db)
                setDashboard(db.dashboard);
                setDashboardData(db.dashboardData)

                console.log("Dashboard loaded:", dashboard)
            }
            setIsLoading(false)
        };

        console.log("refresh use effect:", refresh);
        console.log("propsetup:", propSetup);

        fetchData();
    }, [refresh, propSetup, startDate, endDate]);
    
    const getDashboard = async (): Promise<any>=> {
        //Check if the data is in the cache
        const cacheKey = getCacheKey(did, startDate, endDate)
        const keyExists = cache.hasOwnProperty(cacheKey);

        if(keyExists){
            console.log("Hash used")
            return cache[cacheKey]
            //return dashboardCache[hashIndex].data
        } else {
            try{
                const body = JSON.stringify({
                    "start": startDate.toISOString().split('T')[0],
                    "end": endDate.toISOString().split('T')[0],
                    "pid": pid,
                    "did": did,
                    "rooms": property.rooms,
                    "ara": "4-2400"
                });

               const response = await fetch(`${process.env.REACT_APP_API_URL}/dashboard`, {
                    mode: 'cors',
                    method: 'post',
                    body: body,
                    headers: headers,
                })
        
                const data = await response.json();
                cache[cacheKey] = data;

                console.log("data for dashboard:", data)
                return data
        
            } catch (error) {
              console.log("Error retreiving Dashboard", error)
            }
        }
    }

      //Extract the start and end dates when changing the Sales dropdown
      // This needs to be Monday to Sunday
      function setSalesDates(priorDays: number, end?: Date): void{

        const endDate = end ? dayjs(end) : dayjs();
        
        let priorDate = endDate.subtract(priorDays, 'd') //new Date(new Date().setDate(endDate.getDate() - priorDays));
        //console.log("setSalesDates: ", `${priorDate.toISOString()} - ${endDate.toISOString()}`)
        
        setStartDate(priorDate.toDate());
        setEndDate(endDate.toDate());
        
        setStartDisplayDate(priorDate)
        setEndDisplayDate(endDate)
    }

    function setPreviousWeekDates() {
        const today = new Date();
        const previousSunday = new Date(today);
        previousSunday.setDate(today.getDate() - today.getDay());
        setSalesDates(7, previousSunday)
      }

     function setLastMonthDates() {
        const today = new Date();
        const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      
        const lastDayOfLastMonth = new Date(firstDayOfCurrentMonth);
        lastDayOfLastMonth.setDate(firstDayOfCurrentMonth.getDate() - 1);
      
        const firstDayOfLastMonth = new Date(lastDayOfLastMonth);
        firstDayOfLastMonth.setDate(1);
      
        setStartDate(firstDayOfLastMonth)
        setEndDate(lastDayOfLastMonth)
        setRefresh(new Date())
      }

      function setManualDates() {
        setStartDate(startDisplayDate)
        setEndDate(endDisplayDate) 
        setRefresh(new Date())
      }




    function setWeekEnd(newValue: any): void {
        const weekEnd = new Date(newValue)
        setSalesDates(7,weekEnd)
        setRefresh(new Date())
    }

    const handleClick = useCallback(() => {
        setManualDates();
      }, [startDate, endDate])
    

    return(
        <DashboardLayout>
        <Grid container alignItems="center" >
            <Grid item lg={6}>
                <MDBox py={1} >
                    <h2>{property.name}</h2>
                </MDBox>
            </Grid>
            <Grid item lg={6}>
                <Card>
                <Grid container>
                    <Grid item lg={5}>
                        <MDBox p={2}>
                        <DatePicker 
                              format="DD-MM-YYYY"
                              label="From"
                              value={dayjs(startDisplayDate)}
                              onChange={(newValue) => setStartDisplayDate(newValue)}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item lg={5} >
                        <MDBox p={2}>
                        <DatePicker 
                              format="DD-MM-YYYY"
                              label="To"
                              value={dayjs(endDisplayDate)}
                              onChange={(newValue) => setWeekEnd(newValue)}
                            />
                        </MDBox>
                    </Grid>
                    <Grid item lg={2} >
                        <MDBox p={2}>
                        <MDButton
                            component={Link}
                            to=""
                            variant="gradient"
                            color="light"
                            fullWidth
                            onClick={handleClick}
                          >
                            GO&nbsp;
                        </MDButton>
                        </MDBox>
                    </Grid>
                </Grid>
                </Card>
            </Grid>
        </Grid>
        {isLoading ? <LoadingSpinner /> : (
        
        <Grid container alignItems="center">

        {/* Loop through at this level for each DashboardComponentGroup */

        }
            {dashboard && dashboard.ComponentGroups.map((group, index) => (
                <DashboardComponentGrp key={index} group={group} glTotals={glTotals}/>
            ))}

        </Grid>
        )

        
    }
    </DashboardLayout>
    )   
});

export default DataPage;


